import LeadMagnetHeroTeaser from '@/components/leadmagnet/LeadMagnetHeroTeaser';

export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const necessityCards = [
    {
      icon: 'ri-bar-chart-box-line',
      title: 'Рост конкуренции',
      desc: 'Рынки перенасыщены — конкуренты внедряют <strong>обучение персонала</strong> как системный инструмент. Без развития сотрудников компания теряет позиции.'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Изменение поведения клиентов',
      desc: 'Клиенты стали требовательнее и избирательнее. Чтобы соответствовать ожиданиям, нужно постоянное <strong>развитие компетенций</strong> команды.'
    },
    {
      icon: 'ri-cpu-line',
      title: 'Развитие технологий',
      desc: 'Цифровизация и автоматизация меняют бизнес-процессы. <strong>Обучение сотрудников</strong> работе с новыми инструментами — вопрос выживания.'
    },
    {
      icon: 'ri-star-smile-line',
      title: 'Рост требований к сервису',
      desc: 'Уровень сервиса становится ключевым конкурентным преимуществом. <strong>Корпоративное обучение</strong> помогает командам соответствовать высоким стандартам.'
    },
    {
      icon: 'ri-robot-2-line',
      title: 'Появление ИИ',
      desc: 'Искусственный интеллект трансформирует профессии. <strong>Развитие персонала</strong> позволяет сотрудникам использовать ИИ как инструмент, а не бояться замены.'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Быстрое устаревание знаний',
      desc: 'Знания устаревают за 2-3 года. <strong>Непрерывное обучение</strong> — единственный способ поддерживать актуальность компетенций команды.'
    }
  ];

  const stats = [
    { value: '18+', label: 'лет практики' },
    { value: '100+', label: 'проектов' },
    { value: '450+', label: 'тренингов' },
    { value: '4500+', label: 'участников' }
  ];

  return (
    <>
      <section className="relative min-h-screen flex items-start justify-center overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src="https://storage.readdy-site.link/project_files/a74a1966-be20-475d-bd44-2c6a9fc46c98/79a8809d-8c54-416a-8e29-3ff1f86d1c7c_compressed_IMG_0086.webp"
            alt="Алексей Сивко — корпоративное обучение сотрудников"
            className="absolute top-1/2 left-1/2 w-[177.77777778vh] min-w-full h-[56.25vw] min-h-full -translate-x-1/2 -translate-y-1/2 object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/65 to-black/80"></div>
        </div>

        {/* Subtle grain texture overlay */}
        <div className="absolute inset-0 opacity-[0.03] mix-blend-overlay pointer-events-none" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='1'/%3E%3C/svg%3E")`
        }}></div>

        {/* Hero Content */}
        <div className="relative z-10 max-w-5xl mx-auto px-6 text-center w-full pt-28 md:pt-24">
          {/* H1 */}
          <h1 className="text-3xl md:text-6xl lg:text-7xl font-extrabold text-white mb-6 md:mb-8 leading-[1.08] tracking-tight max-w-4xl mx-auto">
            Корпоративное обучение сотрудников
          </h1>

          {/* Subtitle */}
          <p className="text-base md:text-xl text-white/80 mb-12 max-w-3xl mx-auto leading-relaxed font-light">
            Современное обучение сотрудников помогает не только передавать знания, но и менять поведение сотрудников, повышать качество коммуникации, увеличивать продажи и укреплять корпоративную культуру.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
            <button onClick={() => scrollTo('contact')} className="group bg-teal-600 text-white px-8 py-4 rounded-xl text-sm md:text-base font-semibold hover:bg-teal-500 transition-all duration-300 transform hover:scale-[1.03] whitespace-nowrap cursor-pointer w-full sm:w-auto shadow-lg shadow-teal-600/25 hover:shadow-teal-600/40">
              Подобрать формат обучения
              <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform inline-block"></i>
            </button>
            <LeadMagnetHeroTeaser />
          </div>

          <p className="text-white/60 text-sm md:text-base mb-12 max-w-2xl mx-auto">
            Дальше — подберу формат обучения и пришлю программу под цели вашей компании.
          </p>

          {/* Stats Row */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 max-w-3xl mx-auto">
            {stats.map((stat, i) => (
              <div key={i} className="text-center">
                <div className="text-2xl md:text-4xl font-extrabold text-white mb-1">{stat.value}</div>
                <div className="text-xs md:text-sm text-white/50 uppercase tracking-widest">{stat.label}</div>
              </div>
            ))}
          </div>

          {/* Scroll indicator */}
          <div className="mt-16 md:mt-20 flex justify-center">
            <button onClick={() => scrollTo('why-need')} className="text-white/30 hover:text-white/70 transition-colors cursor-pointer animate-bounce">
              <i className="ri-arrow-down-line text-2xl"></i>
            </button>
          </div>
        </div>
      </section>

      {/* Почему корпоративное обучение стало необходимостью */}
      <section id="why-need" className="py-20 md:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
            Почему корпоративное обучение стало необходимостью
          </h2>
          <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto">
            Бизнес-среда меняется быстрее, чем когда-либо. Компании, которые не инвестируют в развитие сотрудников, теряют конкурентоспособность.
          </p>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {necessityCards.map((card, i) => (
              <div key={i} className="bg-gray-50 p-8 rounded-xl hover:bg-gray-100 transition-colors group">
                <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                  <i className={`${card.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{card.title}</h3>
                <p className="text-gray-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: card.desc }}></p>
              </div>
            ))}
          </div>
          <div className="mt-12 text-center">
            <div className="inline-block bg-teal-50 border border-teal-200 rounded-xl px-8 py-5">
              <p className="text-lg md:text-xl font-bold text-teal-800">
                Сегодня выигрывают компании, которые обучаются быстрее конкурентов
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}